import React from 'react';
import { TextModel } from '~/apis/search';
import { EmptyResultGuide } from '~/app/search/result/_components';
import { NoticeWithIcon, Section, Spacing } from '~/components';
import { Typography } from '@bgzt/ui';

import styles from './EmptyMessage.module.css';

type Props = {
  display: boolean;
  q: string;
  hasFilter: boolean;
  guide?: TextModel[];
  isBlockedKeyword?: boolean;
};
export const EmptyMessage = ({ display = false, q, hasFilter, guide, isBlockedKeyword = false }: Props) => {
  if (!display) return null;

  return (
    <Section>
      <Spacing height={60} />

      {hasFilter && (
        <>
          <NoticeWithIcon iconType="search">
            <Typography variant={'S1'} color={'gray-900'} as={'p'}>
              필터 적용 결과가 없어요
            </Typography>
            <Spacing height={6} />
            <Typography variant={'B5'} color={'gray-600'} as={'p'}>
              필터 설정이나 검색어를 변경해보세요.
            </Typography>
          </NoticeWithIcon>
          <Spacing height={60} />
        </>
      )}

      {!hasFilter && (
        <>
          <Typography variant={'S1'} color={'gray-900'} as={'p'} style={{ textAlign: 'center' }}>
            {isBlockedKeyword ? '제한된 검색어입니다' : '검색어를 확인해 주세요'}
          </Typography>

          <Spacing height={6} />

          <Typography variant={'B5'} color={'gray-600'} as={'p'} className={styles.keyword}>
            {q && `’${q}’`}
          </Typography>

          {!isBlockedKeyword && (
            <>
              <Spacing height={6} />
              <Typography variant={'B5'} color={'gray-600'} as={'p'} style={{ textAlign: 'center' }}>
                현재는 검색 결과가 없어요.
              </Typography>
            </>
          )}

          <Spacing height={60} />
          <EmptyResultGuide guide={guide} isBlockedKeyword={isBlockedKeyword} />
        </>
      )}
    </Section>
  );
};
